import { useAuth } from "../../contexts/authContext";

export default function UserInfos() {
  const {currentUser} = useAuth()
  let fullNameInAR = currentUser? currentUser.displayName: "حظ سعيد";

  return (
    <div id="user-infos">
      <h4>{fullNameInAR}</h4>
      <h3>Categorie &nbsp; الصنف</h3>
      <h4 style={{ color: "#bf222c" }}>Categorie B</h4>
    </div>
  );
}
